import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import fastclick from '@common/fastclick'
import toastPlugin from '@finance/sui/lib/plugins/toast'
import modalPlugin from '@finance/sui/lib/plugins/modal'
import collect from '@common/collect'
// import useragent from '@finance/useragent'
import '@common/sui-sdk'
import { verifyAuth } from '@finance/jssdk-auth'

import router from '@/routes/index'
import store from '@/stores/index'
// import VueLazyload from 'vue-lazyload'

import * as filters from '@/utils/filters'
import { isPROD } from '@/utils/common'

import App from './App.vue'

const osVersion = window.navigator.userAgent.toLowerCase().match(/cpu iphone os (.*?) like mac os/)
if (!osVersion || (osVersion && (window.parseInt(osVersion[1]) < 11))) {
  fastclick.attach(document.body)
}

/** 注册 router hooks  */
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate' // for vue-router 2.2+
])

// 生产环境不显示警告
Vue.config.productionTip = false
Vue.config.devtools = !isPROD

/* =====导入ssvue插件===== */
Vue.prototype.$Collect = collect
Vue.use(toastPlugin)
Vue.use(modalPlugin)

// 注册过滤器
const _f: {
  // eslint-disable-next-line @typescript-eslint/ban-types
  [x: string]: Function
} = filters
Object.keys(_f).forEach((item) => {
  // eslint-disable-next-line @typescript-eslint/ban-types
  const func: Function = _f[item]
  Vue.filter(item, func)
})

/* =====引入调试工具===== */
console.log('process.env.NODE_ENV ', process.env.NODE_ENV)

/* ===== 正式服抓取错误日志 ===== */
if (isPROD) {
  const currentScript: HTMLScriptElement = <HTMLScriptElement>document.currentScript
  const src = currentScript && currentScript.src
  Vue.config.errorHandler = (error) => {
    window._mntError && window._mntError.push({
      jsLink: src,
      info: error.message,
      error
    })
  }
}

const start = async() => {
  await verifyAuth().catch((err: any) => {
    console.log('jssdk鉴权失败', err)
    window._mntError && window._mntError.push({ info: `jssdk鉴权失败 ${JSON.stringify(err)}` })
  })
  const app = new Vue({
    router,
    store,
    render: (h) => h(App),
  })
  app.$mount('#app')
}

start()

// new Vue({
//   router,
//   store,
//   render: (h) => h(App),
// }).$mount('#app')
